module.exports = __webpack_public_path__ + "img/41_10.7dc3ae13.png";